module.exports = __webpack_public_path__ + "static/media/nigel-1.2a413a06.jpg";